// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'


const NilaiCapaianKompetensi = lazy(() => import('../../views/forms/nilai-capaian-kompetensi'))
const ProfilPancasila = lazy(() => import('../../views/forms/profil-pancasila'))
const Validation = lazy(() => import('../../views/forms/validation'))
const Sen = lazy(() => import('../../views/forms/sen'))
const FormLayouts = lazy(() => import('../../views/forms/form-layouts'))
const Radio = lazy(() => import('../../views/forms/form-elements/radio'))
const Input = lazy(() => import('../../views/forms/form-elements/input'))
const FormRepeater = lazy(() => import('../../views/forms/form-repeater'))
const Switch = lazy(() => import('../../views/forms/form-elements/switch'))
const Editor = lazy(() => import('../../views/forms/form-elements/editor'))
const Select = lazy(() => import('../../views/forms/form-elements/select'))
const Textarea = lazy(() => import('../../views/forms/form-elements/textarea'))
const InputMask = lazy(() => import('../../views/forms/form-elements/input-mask'))
const Checkboxes = lazy(() => import('../../views/forms/form-elements/checkboxes'))
const Datepickers = lazy(() => import('../../views/forms/form-elements/datepicker'))
const InputGroups = lazy(() => import('../../views/forms/form-elements/input-groups'))
const NumberInput = lazy(() => import('../../views/forms/form-elements/number-input'))
const FileUploader = lazy(() => import('../../views/forms/form-elements/file-uploader'))

const RoleEntryRoutes = [
  {
    element: <ProfilPancasila />,
    path: '/forms/profil-pancasila'
  },
  {
    element: <Validation />,
    path: '/forms/form-validation'
  },
  {
    element: <FormRepeater />,
    path: '/forms/form-repeater'
  },
  {
    element: <NilaiCapaianKompetensi />,
    path: '/forms/nilai-capaian-kompetensi'
  },
  {
    element: <Sen />,
    path: '/forms/sen'
  }
]

export default RoleEntryRoutes
